import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import {
  CardActionArea,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useAddToFavMutation } from "api/menu";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import SelectDishesCards from "components/SelectDishes1/SelectDishes1Cards";
import { IMAGE_URL } from "config";
import { useGetAllMealPlanQuery } from "api/Mealplans";

const CustomIconButton = styled(IconButton)(({}) => ({
  position: "absolute",
  top: "3px",
  right: "6px",
  background: "#fff",
}));

export const MenuLandingPageCard = ({ showMenu, menus, dishes }) => {
  const [visibleMealPlans, setVisibleMealPlans] = useState(8);
  let navigate = useNavigate();
  const [addToFav, { isLoading }] = useAddToFavMutation();
  const { data: mealplanes } = useGetAllMealPlanQuery();

  // if (!mealplanes) {
  //   return <div>Loading...</div>;
  // }

  const showMoreMealPlans = () => {
    setVisibleMealPlans((prevVisibleMealPlans) => prevVisibleMealPlans + 8);
  };

  console.log("menue11", mealplanes);
  console.log("menue11", menus);
  // const data = [
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "Arabian Falafel Platter Eastern Special",
  //     image: "./images/kabab1.svg",
  //     rating: "4.7",
  //     price: "40",
  //   },
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "Arabian Kebab, Middle East Special",
  //     image: "./images/kabab2.svg",
  //     rating: "4.7",
  //     price: "50",
  //   },
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "lHearty Italian-Style White Bean Soup",
  //     image: "./images/kabab3.svg",
  //     rating: "4.7",
  //     price: "63",
  //   },
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "Salmon with Sweet Chili Sauce (3½ to 4 ounces)",
  //     image: "./images/kabab4.svg",
  //     rating: "4.7",
  //     price: "53",
  //   },
  // ];

  const handleAddDishToFav = (id) => {
    addToFav({ id });
  };

  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: "708px", md: "708px", sm: "auto", xs: "auto" },
        paddingRight: { lg: "24px", md: "24px", sm: "24px", xs: "0px" },
      }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ paddingLeft: "24px", paddingBottom: "24px" }}>
        <Box>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  width: "20px",
                  height: "76px",
                  fontSize: { lg: "24px", md: "24px", sm: "22px", xs: "18px" },
                  fontWeight: "600",
                  fontSize: "24px",
                }}
              >
                <ListItemIcon>
                  <CloseIcon
                    sx={{ color: "#E75C62" }}
                    onClick={toggleDrawer(anchor, false)}
                    onKeyDown={toggleDrawer(anchor, false)}
                  />
                  <ListItemText
                    sx={{
                      paddingRight: {
                        lg: "246px",
                        md: "246px",
                        sm: "246px",
                        xs: "40px",
                      },
                      color: "#000000",
                    }}
                    color="#000000"
                  />{" "}
                  Select Dishes
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>

        <Box
          // component={"container"}
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "block",
              lg: "block",
            },
            backgroundImage: "url(./images/selectdish1.png)",
            backgroundRepeat: "no-repeat",

            width: { lg: "100%", md: "100%", sm: "686px", xs: "95%" },
            height: {
              xl: "357.47px",
              lg: "357.47px",
              md: "310px",
              // md: "800px",
              sm: "310px",
              xs: "200px",
            },
            backgroundSize: {
              lg: "contain",
              md: "cover",
              sm: "contain",
              xs: "cover",
            },
            borderRadius: "6px",
            // backgroundPosition: "center",
          }}
        >
          <Box sx={{}}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                // paddingRight: "24px",
                // paddingLeft: "16px",
                color: "#FFFFFF",
                paddingTop: {
                  lg: "195px",
                  md: "195px",
                  sm: "210px",
                  xs: "100px",
                },

                height: { lg: "115px", md: "115px", sm: "100px", xs: "100px" },
                borderRadius: "6px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: { lg: "100%", md: "100%", sm: "686px", xs: "100%" },
                  justifyContent: "space-between",
                  background:
                    "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
                  borderRadius: "6px",
                }}
              >
                <Box sx={{ paddingLeft: "16px", paddingTop: "6px" }}>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "24px",
                          md: "24px",
                          sm: "20px",
                          xs: "18px",
                        },
                        fontWeight: "600",
                      }}
                    >
                      Main Course
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "18px",
                          md: "18px",
                          sm: "16px",
                          xs: "12px",
                        },
                        fontWeight: "400",
                        paddingTop: "5px",
                      }}
                    >
                      Choose your prefered dishes
                    </Typography>
                    <Box
                      sx={{
                        paddingTop: {
                          lg: "8px",
                          md: "8px",
                          sm: "8px",
                          xs: "4px",
                        },
                        color: "#E75C62",
                        paddingLeft: "14px",
                        height: {
                          lg: "24px",
                          md: "24px",
                          sm: "16px",
                          xs: "12px",
                        },
                      }}
                    >
                      <ErrorIcon
                        sx={{
                          width: {
                            lg: "24px",
                            md: "24px",
                            sm: "16px",
                            xs: "14px",
                          },
                          height: {
                            lg: "24px",
                            md: "24px",
                            sm: "16px",
                            xs: "14px",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    paddingRight: "24px",
                    paddingTop: {
                      lg: "60px",
                      md: "60px",
                      sm: "50px",
                      xs: "40px",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "18px",
                        md: "18px",
                        sm: "16px",
                        xs: "12px",
                      },
                      fontWeight: "600",
                    }}
                  >
                    6/30 Dishes
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box>
          <SelectDishesCards menus={menus} />
        </Box>

        <Box height="96px" sx={{ backgroundColor: "#ffffff" }}>
          <Box
            sx={{
              paddingTop: "20px",
              paddingRight: { lg: "0px", md: "0px", sm: "20px", xs: "20px" },
            }}
          >
            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{
                textTransform: "capitalize",
                fontSize: { lg: "16px", md: "16px", sm: "10px", xs: "10px" },
                fontWeight: "600",
                height: "48px",
                marginBottom: "24px",
                // position: 'sticky',
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
    <Box
        sx={{
          display: "flex",
           flexDirection: "row",
           justifyContent: "right"
        }}
        >
        {visibleMealPlans < mealplanes?.data?.length && (
        <button onClick={showMoreMealPlans}
        style={{
          backgroundColor: "transparent",
          border: "0px",
          cursor: "pointer",
          marginBottom: "10px",
          fontSize: "15px", 
        }}
        ><u>Show More</u></button>
      )}
      </Box>
      <Box
        sx={{
          mt: "30px",
          justifyContent: { xl: "center", sm: "center", xs: "center" },
          alignItems: { xl: "center", sm: "center", xs: "center" },
        }}
      >
        
        <Grid
          container
          spacing={4}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {mealplanes && mealplanes?.data?.length > 0 ? (
            <>
              {mealplanes?.data?.slice(0, visibleMealPlans).map((v, i) => {
                return (
                  <>
                    <Grid xl={3} item lg={3} md={4} sm={6} xs={12}>
                      <Link
                        to={`/Meal_Plan/${v._id}`}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <Card
                          sx={{
                            maxWidth: "100%",
                            paddingBottom: {
                              lg: "12px",
                              md: "12px",
                              sm: "16px",
                              xs: "12px",
                            },
                            borderRadius: "8px",
                            borderColor: "#E1E1E6",
                            backgroundColor: "#FFFFFF",
                            height: { xl: "290px", lg: "262px" },
                          }}
                        >
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="146px"
                              width="311px"
                              image={IMAGE_URL + v.image}
                              alt="green iguana"
                            />

                            {/* <CustomIconButton onClick={()=>handleAddDishToFav(v._id)}>
                        {false?<FavoriteBorderIcon />:<FavoriteIcon style={{color:"#E75C62"}}/>}
                      </CustomIconButton> */}
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // marginLeft: "12px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  <Typography
                                    // gutterBottom
                                    // variant="h5"
                                    component="div"
                                    sx={{
                                      width: "77px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      lineHeight: "16px",
                                      color: "#2B817B",
                                      // marginRight: "145.5px",
                                    }}
                                  >
                                    {v.name}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{ display: "flex", flexDirection: "row" }}
                                >
                                  <img
                                    src="/images/Star.svg"
                                    alt=""
                                    width={"13px"}
                                    height={"12.45px"}
                                  />
                                  <Typography
                                    sx={{
                                      // width: "16px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      lineHeight: "16px",
                                      paddingLeft: "9.5px",
                                    }}
                                  >
                                    {/* {v.ratings.length} */}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                fontWeight="500"
                                lineHeight="26px"
                                width="auto"
                                sx={{
                                  fontSize: {
                                    lg: "18px",
                                    md: "18px",
                                    sm: "16px",
                                    xs: "16px",
                                  },
                                }}
                                // height="52px"
                              >
                                {v.description}.
                              </Typography>

                              <Box
                                sx={{ display: "flex", flexDirection: "row" }}
                              >
                                <img src="./images/tag.svg" alt="" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    // width: "200px",
                                    // height: "20px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    paddingLeft: "9.69px",
                                  }}
                                >
                                  Starting from $"5" (weekly price)
                                </Typography>
                              </Box>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Link>
                    </Grid>
                  </>
                );
              })}
            </>
          ) : (
            <>
              {[1, 2, 3, 4, 5, 6, 7, 8]?.map((v, i) => {
                return (
                  <>
                    <Grid xl={2} item lg={3} md={4} sm={6} xs={12}>
                      <Link
                        onClick={toggleDrawer("right", true)}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <Card
                          sx={{
                            maxWidth: "100%",
                            paddingBottom: {
                              lg: "12px",
                              md: "12px",
                              sm: "16px",
                              xs: "12px",
                            },
                            borderRadius: "8px",
                            borderColor: "#E1E1E6",
                            backgroundColor: "#FFFFFF",
                            height: { xl: "290px", lg: "262px" },
                          }}
                        >
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="146px"
                              width="311px"
                              image={"/images/selectdish1.png"}
                              alt="green iguana"
                            />

                            {/* <CustomIconButton onClick={()=>handleAddDishToFav(v._id)}>
                        {false?<FavoriteBorderIcon />:<FavoriteIcon style={{color:"#E75C62"}}/>}
                      </CustomIconButton> */}
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // marginLeft: "12px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  <Typography
                                    // gutterBottom
                                    // variant="h5"
                                    component="div"
                                    sx={{
                                      width: "77px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      lineHeight: "16px",
                                      color: "#2B817B",
                                      // marginRight: "145.5px",
                                    }}
                                  >
                                    {v.name}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{ display: "flex", flexDirection: "row" }}
                                >
                                  <img
                                    src="/images/Star.svg"
                                    alt=""
                                    width={"13px"}
                                    height={"12.45px"}
                                  />
                                  <Typography
                                    sx={{
                                      // width: "16px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      lineHeight: "16px",
                                      paddingLeft: "9.5px",
                                    }}
                                  >
                                    {/* {v.ratings.length} */}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                fontWeight="500"
                                lineHeight="26px"
                                width="auto"
                                sx={{
                                  fontSize: {
                                    lg: "18px",
                                    md: "18px",
                                    sm: "16px",
                                    xs: "16px",
                                  },
                                }}
                                // height="52px"
                              >
                                Sweet - Usually an enjoyable taste of sugar.
                              </Typography>

                              <Box
                                sx={{ display: "flex", flexDirection: "row" }}
                              >
                                <img src="./images/tag.svg" alt="" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    // width: "200px",
                                    // height: "20px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    paddingLeft: "9.69px",
                                  }}
                                >
                                  Starting from $"5" (weekly price)
                                </Typography>
                              </Box>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Link>
                    </Grid>
                  </>
                );
              })}
            </>
          )}
        </Grid>
        {showMenu && (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={"100%"}
            mt={2}
          >
            <Button
              variant="text"
              onClick={() => {
                navigate("/allmenu");
              }}
              style={{ textDecoration: "underline", textTransform: "none" }}
            >
              See All Menu
            </Button>
          </Box>
        )}
        {/* <Box sx={{
          display:`${dispProp}`,
          flexDirection:'row',
          justifyContent:'center',
          mt:'40px'
        }}>
            <Link to="/allmenu" style={{color:'#2B817B', fontWeight:600, fontSize:'15px'}}>See All Menu</Link>
            
        </Box> */}

        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>
      </Box>
    </>
  );
};
